import { render } from "./DetaildView.vue?vue&type=template&id=9995b642&scoped=true"
import script from "./DetaildView.vue?vue&type=script&lang=js"
export * from "./DetaildView.vue?vue&type=script&lang=js"

import "./DetaildView.vue?vue&type=style&index=0&id=9995b642&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9995b642"]])

export default __exports__